/**
 * SORGU ANAHTARI FABRIKASI — buro paneli.
 *
 * Anahtar TARIH ARALIGINI ICERIR. Icermeseydi aralik degistirildiginde
 * TanStack ayni anahtari gorup onbellekteki ESKI araligin rakamlarini
 * gosterirdi ve kullanici yeni tarihlere bakip eski sayilari okurdu — bir ciro
 * panelinde en sessiz hata sinifi bu.
 *
 * Onek eslemesi TanStack'in varsayilanidir: `dashboardKeys.all` ile yapilan
 * gecersiz kilma altindaki her araligi kapsar (Yenile eylemi bunu kullanir).
 */
export const dashboardKeys = {
  all: ['exchange-dashboard'] as const,

  /** GET /v1/dashboards/exchange — aralik ANAHTARIN PARCASI. */
  range: (startIso: string, endIso: string) =>
    [...dashboardKeys.all, startIso, endIso] as const,
};

/**
 * SORGU ANAHTARI FABRIKASI — musteri paneli.
 *
 * Buro panelinden AYRI bir kok ('customer-dashboard'): ayni kok altinda olsalardi
 * buro panelindeki bir gecersiz kilma musteri sorgularini da dusururdu ve iki ekran
 * birbirinin onbellegini tetikleyerek gereksiz istek uretirdi.
 *
 * Uc ayri kapsam, uc ayri anahtar — hepsi ARALIGI icerir (bkz. dashboardKeys gerekcesi):
 *   mine    : cagiranin kendi verisi
 *   org     : organizasyon geneli (yalniz yonetici)
 *   members : uye kirilimi (yalniz yonetici)
 */
export const customerDashboardKeys = {
  all: ['customer-dashboard'] as const,
  mine: (from: string, to: string) => [...customerDashboardKeys.all, 'mine', from, to] as const,
  org: (from: string, to: string) => [...customerDashboardKeys.all, 'org', from, to] as const,
  members: (from: string, to: string) =>
    [...customerDashboardKeys.all, 'members', from, to] as const,
};
